export default "__VITE_ASSET__Dnbb3R4c__"